import slice from './slice';

export const { setSnackbarValue } = slice.actions;
